export default __webpack_public_path__ + "static/montserrat-v15-latin-regular-fa100f9f573bd66e56081c8bfa2d5818.ttf";